module.exports = __webpack_public_path__ + "img/banana.fe6aede8.png";